export default class Revision {
  static tag(){
    if (typeof this.global() !== "undefined") {
      return this.global().tag;
    }
  }

  static global(){
    return window.playback.Revision;
  }
}
